module.exports = "pegasus/assets/summer-header.png";